import React, { PureComponent } from 'react';

class AboutModal extends PureComponent {
  render() {
    return (
      <div className="AboutModal">
        <h2>About Tickmark Reporting Tool</h2>
        <ul>
          <li>
            <b>Info: </b>
            <a href="mailto:info@tickmark-software.com">
              info@tickmark-software.com
            </a>
          </li>
          <li>
            <b>Support: </b>
            <a href="mailto:support@tickmark-software.com">
              support@tickmark-software.com
            </a>
          </li>
          <br />
          <li>
            <b>Tickmark Software Web: </b>
            <a
              href="https://www.tickmark-software.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.tickmark-software.com
            </a>
          </li>
          <li>
            <b>Tickmark Software Administration Web: </b>
            <a
              href="https://app.tickmark-software.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              app.tickmark-software.com
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

export default AboutModal;
